<template>
    <form
        :action="autocompleteUrl"
        v-on:submit.prevent="search"
        method="get"
        accept-charset="utf-8"
        class="c-form"
    >
        <div class="c-form__item c-form__item--text">
            <input
                type="text"
                :id="'autocomplete-' + parseInt(Math.random() * 1000)"
                v-model="keyword"
                name="search"
                autocomplete="off"
                :placeholder="inputPlaceholder"
                @input="search"
                @focus="showForm"
                :class="{
                    'c-form__input': true,
                    'is-empty': !keyword,
                    'is-open': isOpen,
                }"
                ref="searchInput"
            />
        </div>

        <a
            :href="`/vyhladavanie${keyword ? `?search=${keyword}` : ''}`"
            :class="{
                'c-btn c-btn--secondary sc-search-btn': true,
                'is-loading': isLoading,
                'is-open': isOpen,
            }"
        >
            <i class="ico ico-search"></i>
        </a>

        <button
            v-if="isFormVisible"
            type="button"
            @click="hideForm"
            :class="{
                'c-btn c-btn--secondary': true,
                'is-open': isOpen,
            }"
        >
            <i aria-hidden="true" class="ico ico-x"></i>
        </button>
    </form>
</template>

<script>
import RshopAutocompleteForm from "./../../../../vendor/rshop/frontend/assets/js/components/Autocomplete/Form/index.vue";

export default {
    extends: RshopAutocompleteForm,
    props: {
        isFormVisible: {
            type: Boolean,
            default: false,
        },
        isOpen: {
            type: Boolean,
            default: false,
        },
        inputPlaceholder: {
            type: String,
            required: true,
        },
    },
    methods: {
        showForm() {
            this.$emit("show-form");
        },
        hideForm() {
            this.$emit("hide-form");
        },
    },
    watch: {
        isFormVisible(value) {
            if (value) {
                this.$nextTick(() => {
                    this.$refs.searchInput.focus();
                });
            }
        },
    },
};
</script>
